// core
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from "rxjs";

// services
import { RaptorControlService } from '../../services/raptor-control.service';
import { RaptorStepService } from '../../services/raptor-step.service';
import { RaptorFormService } from '../../services/raptor-form.service';
import { RaptorActionService } from '../../resources/raptor-action.service';

/* page layouts */
let page_settings = {
  "size": "<small|medium|large>", // default - large
  "align": "<left|center|right>", // default - left
  "sidebar": "<true|null>" // default - null
}

@Component({
  selector: 'open-raptor-form',
  templateUrl: './raptor-form.component.html',
  styleUrls: ['./raptor-form.component.scss']
})
export class RaptorFormComponent implements OnInit, OnDestroy {
  @Input() formData: any;
  @Input() manager: any;

  form!: FormGroup;

  raptorEditQuestionSubscription!: Subscription;
  raptorJumpSubscription!: Subscription;
  ratorAddFieldSubscription!: Subscription;
  ratorStepSubscription!: Subscription;
  constructor(
    private raptorControlService: RaptorControlService,
    private raptorStepService: RaptorStepService,
    private raptorFormService: RaptorFormService,
    private raptorActionService: RaptorActionService
  ) {
    // this.raptorStepService.loadingState(true);
   }

  ngOnInit(): void {
    this.raptorActionService.register(this.manager);

    this.raptorEditQuestionSubscription = this.raptorStepService.editQuestion$
      .subscribe((questionKey: string | undefined) => {
        if (questionKey) {
          this.onEdit(questionKey);
        }
     });

    this.raptorJumpSubscription = this.raptorStepService.jump$
      .subscribe((step: string | undefined) => {
        this.raptorFormService.setupStep(this.formData, step);
    });

    this.ratorStepSubscription = this.raptorFormService.step$
      .subscribe((data: any) => {
        this.form = data.form;
        this.formData = data.formData;
      });

    this.ratorAddFieldSubscription = this.raptorControlService.addNewControl$
      .subscribe((group: any) => {
        for (let key in group) {
          this.form.controls[key] = group[key];
        }
        this.raptorFormService.formWatcher(this.formData, this.form);
      });

    // Now the form service does all the heavy lifting to step up the form
    // in order to keep this component a little lighter
    this.raptorFormService.setupStep(this.formData);
    // this.raptorStepService.loadingState(false, 'forward');
  }

  ngOnDestroy(): void {
    if (this.raptorEditQuestionSubscription) {
      this.raptorEditQuestionSubscription.unsubscribe();
    }

    if (this.raptorJumpSubscription) {
      this.raptorJumpSubscription.unsubscribe();
    }

    if (this.raptorEditQuestionSubscription) {
      this.raptorEditQuestionSubscription.unsubscribe();
    }

    if (this.ratorStepSubscription) {
      this.ratorStepSubscription.unsubscribe();
    }

    if (this.ratorAddFieldSubscription) {
      this.ratorAddFieldSubscription.unsubscribe();
    }
  }

  async onSubmit(): Promise<void> {
    this.raptorFormService.submit(this.form, this.formData);
  }

  onReset(): void {
    this.raptorFormService.reset(this.formData);
  }

  onEdit(questionKey: string): void {
    this.raptorFormService.edit(questionKey, this.formData);
  }
}
